import { render, staticRenderFns } from "./adminban.vue?vue&type=template&id=34767f4f&"
import script from "./adminban.vue?vue&type=script&lang=js&"
export * from "./adminban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports